import React from 'react';
import { Menu } from 'antd';

interface DropdownHeaderMenuProps {
  onClickDropDown: ({ key }: { key: string }) => void;
}

export const DropdownHeaderMenu = (props: DropdownHeaderMenuProps) => {
  return (
    <Menu onClick={props.onClickDropDown}>
      <Menu.Item key="0">
        <div>Logout</div>
      </Menu.Item>
    </Menu>
  );
};
